import { ajax } from 'jquery';
import auth from '@/lib/auth';
import config from '@/lib/config';


export default {
    isRefreshingToken: false,

    get(url, data, callback) {
        this.send('GET', url, data, callback);
    },

    post(url, data, callback, baseURL) {
        this.send('POST', url, data, callback, baseURL);
    },

    patch(url, data, callback) {
        this.send('PATCH', url, data, callback);
    },

    put(url, data, callback) {
        this.send('PUT', url, data, callback);

    },

    update(url, data, callback) {
        this.send('UPDATE', url, data, callback);
    },

    delete(url, data, callback) {
        this.send('DELETE', url, data, callback);
    },

    request(method, url, data, callback) {
        let myself = this;
        let headers;
        auth.user.loader = true;
        if (auth.user.authenticated) {
            headers = {
                'Authorization': auth.getAuthHeader()
            };
        } else {
            headers = {};
        }
        let setup;
        setup = {
            headers: headers,
            url: url,
            contentType: 'application/json; charset=utf-8',
            method: method,
            success: function(data) {
                //console.log(data);
                auth.user.loader = false;
                callback(null, data);
            },
            error: function(xhr, status, error) {
                console.log(xhr);
                console.log(status);
                console.log(error);
                auth.user.loader = false;
                if (status == 'error' && ((xhr.responseJSON && xhr.responseJSON.msg === 'Token has expired') || xhr.responseJSON && xhr.responseJSON.msg == 'Token has been revoked')) {
                    console.log('Token expired');
                    const originalReq = setup;
                    if (!myself.isRefreshingToken) {
                        myself.isRefreshingToken = true;
                        $.ajax({
                            headers: { 'Authorization': 'Bearer ' + localStorage.getItem('refresh_token') },
                            url: config.API_URL + 'auth/refresh',
                            contentType: 'application/json; charset=utf-8',
                            method: 'POST',
                            success: function(response) {
                                //console.log('refresh token', response);
                                localStorage.setItem('token', response.access_token);
                                //console.log(originalReq);
                                myself.isRefreshingToken = false;
                                originalReq.headers = { 'Authorization': auth.getAuthHeader() };
                                ajax(originalReq);
                                // return true;
                            },
                            error: function(xhr, status, error) {
                                console.log(xhr, status, error);
                                myself.isRefreshingToken = false;
                                if (status == 'error' && (xhr.responseJSON && (xhr.responseJSON.msg === 'Token has expired' || xhr.responseJSON.msg == 'Token has been revoked'))) {
                                    window.location = "#/auth/Login";
                                }
                            }
                        });
                    }
                } else if (status == 'error' && error === 'UNPROCESSABLE ENTITY') {
                    auth.user.authenticated = false;
                    // refreshToken
                    window.location = "#/auth/Login";
                } else if (status == 'error' && error == 'UNAUTHORIZED') {
                    if (url !== 'auth')
                        window.location = "#/do-not-have-access";
                } else {
                    console.log('return call');
                    callback({
                        status,
                        error,
                        xhr
                    }, null);
                }
            }
        };
        if (data instanceof FormData) {
            setup.contentType = false;
            setup.processData = false;
        } else {
            data = JSON.stringify(data);
        }
        if (data != '{}')
            setup.data = data;
        ajax(setup);
    },
    send(method, url, data, callback, baseURL=config.API_URL) {
        let urlwithBase = baseURL + url.replace(/^\/+/g, '');
        this.request(method, urlwithBase, data, callback);
    },
};


// WEBPACK FOOTER //
// ./src/lib/http.js